import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ConversationsIcon } from 'assets/icons';
import routes from 'routes';
import { RAYCHAT_APP_V2_URL } from 'utils/constants';
import LoginForm from './LoginForm';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const LoginCard = (props) => {
  const { getTranslation } = useTranslation('AUTH');
  const { t } = getTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralParam = queryParams.get('referral');

  return (
    <div className='login_box'>
      <h4>{t('LOGIN_HEADER_TITLE')}</h4>
      <p>
        {' '}
        {t('LOGIN_HEADER_SUB_TITLE')}
        {'  '}
        <span>
          <Link
            to={
              Boolean(referralParam)
                ? `${routes.signup}?referral=${referralParam}`
                : routes.signup
            }
          >
            {t('LOGIN_HEADER_SIGNUP_TEXT')}
          </Link>
        </span>
      </p>
      <LoginForm />
      <p className='one_time_verification'>
        {t('LOGIN_ONE_TIME_VERIFICATION')}{' '}
        <span>
          <Link to={routes.oneTimeVerification}>
            {t('LOGIN_ONE_TIME_VERIFICATION_CLICK')}
          </Link>
        </span>
      </p>
      <div className='webapp'>
        <a href={RAYCHAT_APP_V2_URL} className='flex'>
          <img src={ConversationsIcon} alt='' />
          <h5>{t('LOGIN_ENTER_WEBAPP_LINK')}</h5>
        </a>
      </div>
    </div>
  );
};

export default LoginCard;
